<template>
    <div class="c-reservation-success">
        <div class="c-reservation-success__header">
            <div class="sc-icon">
                <i class="ico ico-tick" aria-label="hidden"></i>
            </div>

            <div class="sc-title">
                {{ $t('BranchReservation.Success.title') }}
            </div>

            <div
                class="sc-text"
                v-html="replaceTranslate(
                    $t('BranchReservation.Success.text'),
                    '<strong>' + orderId + '</strong>',
                    '<br><strong>',
                    selectedBranch.custom_reservation_cutoff,
                    '</strong><br>'
                )"
            >
            </div>
        </div>

        <div class="c-reservation-success__main">
            <div class="c-reservation-success__branch">
                <ReservationSelect />
            </div>

            <div class="c-reservation-success__delimiter"></div>

            <div class="c-reservation-success__product">
                <ReservationProduct />
            </div>
        </div>

        <div class="c-reservation-success__footer">
            <button type="button" class="c-btn c-btn--secondary" data-dismiss="modal">
                {{ $t('BranchReservation.Success.button') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { replaceTranslate } from "Functions/replaceTranslate"
import ReservationProduct from 'VueComponents/BranchReservation/ReservationProduct';
import ReservationSelect from 'VueComponents/BranchReservation/ReservationSelect';

export default {
    components: {
        ReservationProduct,
        ReservationSelect,
    },
    methods: {
        replaceTranslate: replaceTranslate,
    },
    computed: {
        ...mapGetters([
            'selectedBranch',
            'orderId'
        ]),
        ...mapState([
            'orderId'
        ]),
    },
}
</script>
